import 'edge/quoteandbind/common/models/Submission';

export default ['$q', 'JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = endpointConfig.customQuoteEndpoint;

    return {
        setSelectedVersionOnSubmission: function setSelectedVersionOnSubmission(quoteID, branchName, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'setSelectedVersionOnSubmission', [quoteID, branchName, sessionUUID]);
        },

        updateCustomQuote: function updateCustomQuote(customQuoteDTO) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateCustomQuote', [customQuoteDTO]);
        },

        updateCustomQuoteCoverages: function updateCustomQuoteCoverages(customQuoteDTO) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateCustomQuoteCoverages', [customQuoteDTO]);
        },

        forceUpdateCustomQuoteCoverages: function forceUpdateCustomQuoteCoverages(customQuoteDTO) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'forceUpdateCustomQuoteCoverages', [customQuoteDTO]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/services/CustomQuoteService.js
// module id = 856
// module chunks = 0